export default "__VITE_ASSET__Bqnn73az__"